export const EXTENDED_HOLIDAYS_MESSAGE = '';

// = (() => {
//   // TODO -- Clarify if we're still doing this
//   // const currentYear = new Date().getFullYear();
//   // return `Buying as a gift? Full-priced orders placed between November 28th, ${currentYear} and December 9th, ${currentYear}  can be returned for a refund until January 6, ${
//   //   currentYear + 1
//   // }.`;
//   return '';
// })();
